App.filter('responseTypeFilter', function() {
    return function(input) {
        return input.replace(/_/g, ' ');
    }
});